import { useAssetTrack } from '@casops/routes/home/geofence/components/asset-track-card/useAssetTrack';
import { Fragment, ReactElement } from 'react';
import { GeoJSON, Pane } from 'react-leaflet';
import { TRACKS_PANE_ZINDEX } from '../../mapConfig';

const strokeWeight = 1;
const innerLineWeight = 4;
const outerLineWeight = innerLineWeight + 2 * strokeWeight;
const fillColor = '#72E06A';
const outlineColor = '#000000';

interface TrackDisplayProps {
  trackId: string;
  index: number;
}

export const TrackDisplay = ({ trackId, index }: TrackDisplayProps): ReactElement => {
  const { trackRecord, isTrackRecordValid, data } = useAssetTrack({ trackId });

  const showTrack = trackRecord && isTrackRecordValid && trackRecord.visible && data;

  // Create a unique pane for each track record.
  return (
    <Pane name={trackId} key={trackId} style={{ zIndex: TRACKS_PANE_ZINDEX + index }}>
      {showTrack &&
        data.tracks.map(({ line }, idx) => {
          return (
            <Fragment key={idx}>
              {/* Continuous line behind the other line segments that gives the illusion of an outline. */}
              <GeoJSON
                data={line}
                style={{ weight: outerLineWeight, color: outlineColor }}
                pmIgnore={true}
              />
              {/* Main line segments */}
              <GeoJSON
                data={line}
                style={{ weight: innerLineWeight, color: fillColor }}
                pmIgnore={true}
              />
            </Fragment>
          );
        })}
    </Pane>
  );
};

export default TrackDisplay;
